import { createContext, useContext, useState } from 'react';

const ProjectFormContext = createContext();

export const ProjectFormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    // Contact Info (Step 1)
    email: '',
    name: '',
    company: '',
    message: '',
    
    // Survey (Step 2)
    services: [],
    technologies: [],
    budget: '',
    timeline: '',
    projectStatus: [],
    platforms: [],
    hasDesign: '',
    hasTechSpec: '',
    developmentStage: '',
    prototypeLink: '',
  });

  const [leadId, setLeadId] = useState(null);

  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addService = (service) => {
    setFormData(prev => ({
      ...prev,
      services: [...new Set([...prev.services, service])]
    }));
  };

  const removeService = (service) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.filter(s => s !== service)
    }));
  };

  const addTechnology = (tech) => {
    setFormData(prev => ({
      ...prev,
      technologies: [...new Set([...prev.technologies, tech])]
    }));
  };

  const removeTechnology = (tech) => {
    setFormData(prev => ({
      ...prev,
      technologies: prev.technologies.filter(t => t !== tech)
    }));
  };

  const toggleArrayField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].includes(value)
        ? prev[field].filter(item => item !== value)
        : [...prev[field], value]
    }));
  };

  const resetForm = () => {
    setFormData({
      email: '',
      name: '',
      company: '',
      message: '',
      services: [],
      technologies: [],
      budget: '',
      timeline: '',
      projectStatus: [],
      platforms: [],
      hasDesign: '',
      hasTechSpec: '',
      developmentStage: '',
      prototypeLink: '',
    });
    setLeadId(null);
  };

  return (
    <ProjectFormContext.Provider
      value={{
        formData,
        updateFormData,
        addService,
        removeService,
        addTechnology,
        removeTechnology,
        toggleArrayField,
        resetForm,
        leadId,
        setLeadId,
      }}
    >
      {children}
    </ProjectFormContext.Provider>
  );
};

export const useProjectForm = () => {
  const context = useContext(ProjectFormContext);
  if (!context) {
    throw new Error('useProjectForm must be used within ProjectFormProvider');
  }
  return context;
};
